import React, { useEffect, useState } from 'react'
import { Image } from 'react-konva'

export const AreaInputUrlImage = (props: any) => {
    const [image, setImage] = useState()
    let tmpImage

    useEffect(() => {
        if (props.src) {
            loadImage()
        }
        return () => {
            if (tmpImage) {
                tmpImage.removeEventListener('load', handleLoad)
            }
        }
    }, [props.src])

    const loadImage = () => {
        // save to "this" to remove "load" handler on unmount
        tmpImage = new window.Image()
        tmpImage.src = props.src
        tmpImage.addEventListener('load', handleLoad)
    }
    const handleLoad = () => {
        // after setState react-konva will update canvas and redraw the layer
        // because "image" property is changed
        setImage(tmpImage)
        // if you keep same image object during source updates
        // you will have to update layer manually:
        // this.imageNode.getLayer().batchDraw();
    }

    const handleDragEnd = () => {}

    return <Image {...props} image={image} />
}
